import React, { Component } from "react";

import styles from "./styles.scss";
// import { connect } from "react-redux";
import Select from 'react-select';
import AsyncSelect from "react-select/lib/Async";

import CSSModules from "react-css-modules";
import { Button, CircularProgress } from "@material-ui/core";

import CirclePlusIconSrc from "../../assets/Icons/circle-plus.svg"
import FolderPlusIconSrc from "../../assets/Icons/folder-plus.svg"
import DeleteIconSrc from "../../assets/Icons/trash-x.svg";

import tagService from "../../services/tags";
import masterImportService from "../../services/masterImport";


@CSSModules(styles, { allowMultiple: true })
class TagLabelConfiguration extends Component {

  constructor(props) {

    super(props);
    this.state = {
      id: props.match.params.id,
      label: props.match.params.label,
      showPreviewPoints: false,
      previewPoints: null,
      allTags: null,
      isBusy: true,
      tagLabelConfig: null,
      isGatheringPreviewPoints: false,
      isSavingConfiguration: false
    };
  }

  componentDidMount() {

    const tagsPromise = tagService
      .getTags()
      .then(data => {
        this.setState({ allTags: data });
      });

    const tagLabelPromise = masterImportService
      .getTagLabelConfiguration(this.state.label)
      .then(data => {

        this.setState({ tagLabelConfig: data });

        if (data.configurationStatus === "complete")
          this.previewPoints(data);

      });

    Promise.all([tagsPromise, tagLabelPromise])
      .then(() => {
        this.setState({ isBusy: false });
      })


  }

  /** Callback ACCEPTS an array of values */
  loadValuesForTag(tag, terms) {

    return new Promise(async resolve => {
      tagService.getTagValues(tag, null).then(tags => {

        if (terms == null || terms === "")
          resolve(tags);

        const filteredTags = tags.filter(i => i.toLowerCase().includes(terms.toLowerCase()));
        resolve(filteredTags);

      });
    });
  };

  addFilter(group) {
    group.filters.push({});
    this.setState({ tagLabelConfig: this.state.tagLabelConfig });
  }

  deleteFilter(group, filter) {
    group.filters = group.filters.filter(x => x !== filter);
    this.setState({ tagLabelConfig: this.state.tagLabelConfig });
  }

  addGroup() {
    this.state.tagLabelConfig.configuration.groups.push({ filters: [{}] })
    this.setState({ tagLabelConfig: this.state.tagLabelConfig });
  }

  deleteGroup(group) {
    this.state.tagLabelConfig.configuration.groups = this.state.tagLabelConfig.configuration.groups.filter(x => x !== group);
    this.setState({ tagLabelConfig: this.state.tagLabelConfig });
  }

  transformTagLabel(label) {
    switch (label) {
      case "config_incomplete":
        return "Incomplete";
      case "complete":
        return "Complete"
      default:
        return "Invalid";
    }
  }

  /** Saves configuration to DB  */
  async saveConfiguration() {

    this.setState({ isSavingConfiguration: true });
    
    try {

      const res = await masterImportService
        .updateTagLabelConfiguration(this.state.tagLabelConfig, this.state.id);

      // Update status of configuration with returned value. Indicates whether setup is complete.
      this.state.tagLabelConfig.configurationStatus = res.tagConfigurationStatus;

      this.setState({ tagLabelConfig: this.state.tagLabelConfig, isSavingConfiguration: false });

      if (res.tagConfigurationStatus === "complete")
        this.previewPoints();


    } catch (e) {
      console.error("Error saving configuration: ", e);
    }
  }

  /** Returns a list of objects which will be affected by this configuration */
  async previewPoints(data) {

    this.setState({ isGatheringPreviewPoints: true });

    data = data || this.state.tagLabelConfig;

    for (let i = 0; i < data.configuration.groups.length; i++) {

      const group = data.configuration.groups[i];

      let previewPoints = null;

      try {
        const res = await tagService.advancedSearch(group.groupTag, group.filters);

        let mrg = tagService.mergePointsFromAdvancedSearch(res);
        previewPoints = mrg.sort((a,b) => a.value > b.value ? 1 : -1);

      } catch (e) {
        console.error("Search returned no results for group index: " + i + ". This may just indicate no matches were found. E:", e);
        previewPoints = null
      }

      this.setState({ showPreviewPoints: true, previewPoints });
    }

    this.setState({ isGatheringPreviewPoints: false });
  }

  render() {

    if (this.state.isBusy === true)
      return <div class={"center-children full-height"}><CircularProgress /></div>;

    if (this.state.label == null)
      return <div>No Label specified.</div>

    if (this.state.tagLabelConfig == null)
      return <div>Error loading data</div>

    const tagLabel = this.state.tagLabelConfig;
    const groups = this.state.tagLabelConfig.configuration.groups;

    const groupTagValueGroups = this.state.previewPoints;
    let distinctGroupTags = [];
    if(groupTagValueGroups)
      distinctGroupTags = [...(new Set(groupTagValueGroups.map(level => level.tag)))];


    return (

      <div>

        {/* I'm not really sure what the data format of this will be... */}
        <div styleName={"status-bar"}>
          <h3>{this.state.tagLabelConfig.label}</h3>
          <div styleName={"status-indication"}
               status={tagLabel.configurationStatus}>
            {this.transformTagLabel(tagLabel.configurationStatus)}
          </div>
        </div>


        <div style={{ border: "1px solid #dedede", borderRadius: "0.5rem", padding: "0.5rem" }}>

          {/* Groups */}
          <div styleName={"group-container"}>
            {groups && groups.map((group, i) => {
              return (
                <div key={i}
                     styleName={"group-filter-container"}>

                  {/* Group Tag */}
                  <div>
                    <h4>Group Tag</h4>
                    <div style={{ marginTop: "0.5rem" }}>
                      <Select
                        name="tag-configuration-group-tag"
                        value={[group.groupTag]}
                        onChange={(x) => {
                          console.log("Updated: ", x);
                          group.groupTag = x;
                          this.setState({ tagLabelConfig: this.state.tagLabelConfig });
                        }}
                        options={this.state.allTags}
                        getOptionLabel={option => option}
                        getOptionValue={option => option}
                      />
                    </div>

                  </div>

                  {/* Binding Tag */}
                  <div>
                    <h4>Binding Tag <span style={{fontSize: "11px"}}>&nbsp; Optional. Use to bind/link process variables to single points in a rule</span></h4>
                    <div style={{ marginTop: "0.5rem" }}>
                      <Select
                        name="tag-configuration-binding-tag"
                        value={[group.bindingTag]}
                        onChange={(x) => {
                          console.log("Updated: ", x);
                          group.bindingTag = x;
                          this.setState({ tagLabelConfig: this.state.tagLabelConfig });
                        }}
                        options={this.state.allTags}
                        getOptionLabel={option => option}
                        getOptionValue={option => option}
                      />
                    </div>

                  </div>

                  {/* Filters */}
                  <div>
                    <h4>Filters</h4>
                    <div styleName={"filters-container"}>

                      {/* Headers */}
                      <span>Tag</span>
                      <span>Value</span>
                      <div></div>

                      {/* Loop over all Filters */}
                      {group.filters.map((filter, z) => {

                        return (
                          <React.Fragment key={z}>

                            {/* Tag */}
                            <div style={{ width: "100%" }}>
                              <Select
                                name="tag-configuration-filter-tag"
                                value={[filter.tag]}
                                onChange={(x) => {

                                  // Clear filter value if we have switched tag to filter on.
                                  if (filter.tag !== x)
                                    filter.value = null;

                                  filter.tag = x;

                                  this.setState({ tagLabelConfig: this.state.tagLabelConfig });

                                }}
                                options={this.state.allTags}
                                getOptionLabel={option => option}
                                getOptionValue={option => option}
                              />
                            </div>

                            {/* Value */}
                            <div style={{ width: "100%" }}>
                              <AsyncSelect
                                name="tag-configuration-filter-valued"
                                value={[filter.value]}
                                onChange={(x) => {
                                  filter.value = x;
                                  this.setState({ tagLabelConfig: this.state.tagLabelConfig });
                                }}
                                loadOptions={(terms, callback) => this.loadValuesForTag(filter.tag, terms, callback)}
                                getOptionLabel={option => option}
                                getOptionValue={option => option}
                              />
                            </div>

                            {/* Deleto */}
                            <div>
                              {(z !== 0 &&
                                <img src={DeleteIconSrc}
                                     styleName={"icon-button"}
                                     alt="trash can icon (delete)"
                                     onClick={() => this.deleteFilter(group, filter)}></img>)
                              }
                            </div>

                          </React.Fragment>
                        );

                      })}
                    </div>
                  </div>

                  <Button onClick={() => this.addFilter(group)}
                          style={{ float: "right", maxWidth: "160px", marginLeft: "auto" }}
                          variant="outlined">
                    Add Filter
                    <img src={CirclePlusIconSrc}
                         alt={"'Add Filter' button"}
                         styleName={"icon-button"}></img>
                  </Button>

                  {(i !== 0 && <button onClick={() => this.deleteGroup(group)}>Delete Group</button>)}

                </div>

              );
            })}
          </div>

          {/* Save */}
          <Button onClick={() => this.addGroup()}
                  style={{
                    marginTop: "1rem",
                    backgroundColor: "white"
                  }}
                  variant="flat">
            Add Group
            <img src={FolderPlusIconSrc}
                 alt={"'Add Group' button"}
                 styleName={"icon-button"}></img>
          </Button>

        </div>


        <div styleName={"update-buttons"}>
          <div style={{display:"flex", flexDirection:"column"}}>
            <Button onClick={() => this.previewPoints()}
                    style={{
                      display: "block",
                      backgroundColor: "white",
                      color: "rgb(51,51,51)"
                    }}
                    variant="flat"
                    color={"secondary"}
                    disabled={this.state.isGatheringPreviewPoints}>
              Preview Points
            </Button>
            {
              this.state.isGatheringPreviewPoints == true &&
              <div className={"indefinite-load"}>
                <span></span>
                <div>Gathering preview points...</div>
              </div>
            }
          </div>

          <div style={{display:"flex", flexDirection:"column"}}>
            <Button onClick={() => this.saveConfiguration()}
                    style={{
                      display: "block",
                      backgroundColor: "white",
                      color: "rgb(51,51,51)"
                    }}
                    variant="flat"
                    color={"primary"}
                    disabled={this.state.isSavingConfiguration}>
              Save Configuration
            </Button>
            {
              this.state.isSavingConfiguration == true &&
              <div className={"indefinite-load"}>
                <span></span>
                <div>Saving configuration...</div>
              </div>
            }
          </div>
        </div>


        {/* Preview Points, grouped by group */}
        {(this.state.showPreviewPoints && <div>

          <h3 style={{ marginTop: "2rem" }}>Sample Points</h3>

          {distinctGroupTags.map((groupTag, i) => {

            return (
              <div key={i}>

                <h4>{groupTag}</h4>

                {groupTagValueGroups.filter(x => x.tag === groupTag).map((groupTagValueGroup, index) => {
                  return (
                    <div key={index}
                         styleName={"group-tag-value-container"}
                         style={{margin: "0.5rem 0"}}>
                      <h5 style={{marginTop: "0"}}>{groupTagValueGroup.value}</h5>
                    <table styleName={"sample-table"}>
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Database ID</th>
                        <th>Object ID</th>
                        <th>Units</th>
                      </tr>
                      </thead>
                      <tbody>
                      {groupTagValueGroup.points && groupTagValueGroup.points.length > 0 && groupTagValueGroup.points.map((data, z) => {
                        return (
                          <tr key={z}>
                            <td>{data.name}</td>
                            <td>{data.databaseID}</td>
                            <td>{data.objectID}</td>
                            <td>{data.units}</td>
                          </tr>
                        )
                      })}
                      </tbody>
                    </table>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>)}

      </div>

    );
  }

}

export default TagLabelConfiguration;



// WEBPACK FOOTER //
// ./src/components/TagLabelConfiguration/TagLabelConfiguration.js